
// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration for noor-navigator-5n4d4
const firebaseConfig = {
  apiKey: "AIzaSyDyi2YhFvLK0RChPYwyAXnZ1ViVuoyGJRw",
  authDomain: "noor-navigator-5n4d4.firebaseapp.com",
  projectId: "noor-navigator-5n4d4",
  storageBucket: "noor-navigator-5n4d4.appspot.com",
  messagingSenderId: "904216974625",
  appId: "1:904216974625:web:e9150d65daf82f1e221a60"
};


// Initialize Firebase for client-side
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);


export { app, auth, storage, db };
